// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"c459726a","359":"d27bec00","535":"6d758bcb","536":"f6b72da0","955":"d80f1bad"}[chunkId] + ".chunk.js";
};